import { Spin } from 'antd'
import { DocumentThumbnail } from 'features/knowledgeDocumentViewer/components/DocumentThumbnail'
import {
  getCantileverDocumentId,
  getSystemDocumentBqId,
  type SystemDocumentEntry,
} from 'features/knowledgeDocumentViewer/types/systemDocumentEntries'
import styled from 'styled-components'

import { Box } from './types'

const TooltipContainer = styled.div`
  display: flex;
  flex-direction: column;
  min-width: 10rem;
  max-width: 16rem;
`

const TooltipLabel = styled.div`
  font-size: 0.625rem;
  color: ${(props) => props.theme.forecast.secondaryText};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`

const TooltipType = styled.div`
  font-size: 0.725rem;
  color: ${(props) => props.theme.forecast.secondaryText};
`

const ThumbnailContainer = styled.div`
  width: 100%;
  height: 8rem;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  background-color: ${(props) => props.theme.forecast.cardGroupBackground};
  border-radius: 0.25rem;
`

const DocumentTitle = styled.div`
  font-size: 0.75rem;
  font-weight: 500;
  color: ${(props) => props.theme.forecast.defaultText};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  padding-bottom: 0.5rem;
`

const ClickHint = styled.div`
  font-size: 0.625rem;
  color: ${(props) => props.theme.forecast.secondaryText};
  padding-top: 0.375rem;
`

interface OffPageConnectorTooltipProps {
  box: Box
  systemDocumentEntries: SystemDocumentEntry[]
  isLoading: boolean
}

export function OffPageConnectorTooltip({
  box,
  systemDocumentEntries,
  isLoading,
}: OffPageConnectorTooltipProps) {
  const linkedDocument = systemDocumentEntries[0] ?? null

  const documentTitle =
    linkedDocument?.entry.data.document_title ||
    linkedDocument?.entry.data.title ||
    linkedDocument?.entry.data.filename

  const linkedDocumentCount = systemDocumentEntries.length

  return (
    <TooltipContainer>
      <TooltipLabel>{box.label || `Box ${box.id}`}</TooltipLabel>

      {isLoading ? (
        <ThumbnailContainer>
          <Spin size='small' />
        </ThumbnailContainer>
      ) : linkedDocument ? (
        <>
          {documentTitle && <DocumentTitle>{documentTitle}</DocumentTitle>}
          <ThumbnailContainer>
            <DocumentThumbnail
              documentId={linkedDocument.entry.id}
              alt={documentTitle ?? ''}
              filename={linkedDocument.entry.data.filename}
              bqDocumentId={getSystemDocumentBqId(linkedDocument)}
              cantileverDocumentId={getCantileverDocumentId(linkedDocument)}
              documentHostsHydrated
            />
          </ThumbnailContainer>
        </>
      ) : null}

      {linkedDocumentCount > 1 && (
        <TooltipType>{linkedDocumentCount} linked documents</TooltipType>
      )}

      <ClickHint>Click to open • Cmd/Ctrl + click for new tab</ClickHint>
    </TooltipContainer>
  )
}
